export default "__VITE_ASSET__4fa9299d__"